import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Calendar, LucideAngularModule, Sparkles, X } from 'lucide-angular';
import { ImageErrorDirective } from '@shared/directives/image-error.directive';
import { ModalBgComponent } from '@shared/components/modal-bg/modal-bg.component';
import { NewsletterService } from '../../services/newsletter.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-newsletter-modal',
    imports: [ModalBgComponent, ImageErrorDirective, LucideAngularModule, TranslatePipe],
    templateUrl: './newsletter-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterModalComponent {
    private readonly newsletterS = inject(NewsletterService);

    post = this.newsletterS.postToShow;

    protected readonly XIcon = X;
    protected readonly CalendarIcon = Calendar;
    protected readonly SparklesIcon = Sparkles;

    handleClose() {
        this.newsletterS.closePost();
    }
}
